module.exports = __webpack_public_path__ + "img/shibcoin-logo.25c4df26.svg";